import {
  Box,
  HStack,
  IconButton,
  Select,
  Spinner,
  Table,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
  useToast,
} from "@chakra-ui/react";
import { useState } from "react";
import { FaEye } from "react-icons/fa";
import { Link } from "react-router-dom";
import axiosInstance from "../../config/axiosInstance";

const OrdersTable = ({ data = [], fetchOrders, fetchStats }) => {
  const toast = useToast();
  const [loadingStatusId, setLoadingStatusId] = useState(null);

  const handleStatusChange = async (orderId, orderDetailId, newStatus) => {
    try {
      setLoadingStatusId(orderDetailId);
      await axiosInstance.put(
        `/api/orders/${orderId}/status`,
        {
          orderDetailId,
          status: newStatus,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      toast({
        title: "Status updated successfully",
        status: "success",
        duration: 2000,
        isClosable: true,
      });
      fetchStats();
      fetchOrders();
    } catch (err) {
      toast({
        title: "Failed to update status",
        description: err.response?.data?.message || "Something went wrong",
        status: "error",
        duration: 2000,
        isClosable: true,
      });
    } finally {
      setLoadingStatusId(null);
    }
  };

  return (
    <Box overflowX="auto" border="1px solid #e2e8f0" borderRadius="md">
      <Table size="sm">
        <Thead bg="gray.100">
          <Tr>
            <Th>S.No</Th>
            <Th>Bill No</Th>
            <Th>Item & Due Date</Th>
            <Th>Order Date</Th>
            <Th>Assigned By</Th>
            <Th>Action</Th>
            <Th>Status</Th>
          </Tr>
        </Thead>
        <Tbody>
          {data.length === 0 ? (
            <Tr>
              <Td colSpan={7} textAlign="center">
                No orders found
              </Td>
            </Tr>
          ) : (
            data.map((order, index) => (
              <Tr key={`${order._id}-${order.orderDetail._id}`}>
                <Td>{index + 1}</Td>
                <Td>{order.billNumber || "N/A"}</Td>
                
                {/* Item + Delivery Date */}
                <Td>
                  <Box>
                    <Box fontWeight="bold">{order.orderDetail.item}</Box>
                    <Box fontSize="xs" color="gray.500">
                      Due: {order.orderDetail.deliveryDate
                        ? new Date(order.orderDetail.deliveryDate).toLocaleDateString()
                        : "N/A"}
                    </Box>
                  </Box>
                </Td>

                {/* Order Created Date */}
                <Td>{new Date(order.orderDate).toLocaleDateString()}</Td>

                <Td>{order.createdBy || "Receptionist"}</Td>
                
                <Td>
                  <HStack spacing={2}>
                    <Link to={`/dashboard/order/${order._id}`}>
                      <IconButton
                        icon={<FaEye />}
                        size="sm"
                        aria-label="View"
                      />
                    </Link>
                  </HStack>
                </Td>

                <Td>
                  <Select
                    size="sm"
                    value={order.orderDetail.measurements?.status || "in-progress"}
                    onChange={(e) =>
                      handleStatusChange(
                        order._id,
                        order.orderDetail._id,
                        e.target.value
                      )
                    }
                    isDisabled={loadingStatusId === order.orderDetail._id}
                  >
                    <option value="in-progress">In Progress</option>
                    <option value="done">Done</option>
                    <option value="cancel">Cancel</option>
                  </Select>
                  {loadingStatusId === order.orderDetail._id && (
                    <Spinner size="xs" ml={2} />
                  )}
                </Td>
              </Tr>
            ))
          )}
        </Tbody>
      </Table>
    </Box>
  );
};

export default OrdersTable;
